
import React, {useEffect, useMemo, useState} from 'react';
import { Helmet } from "react-helmet";
import {
    Link, useLocation,
} from "react-router-dom";
import { NavHashLink } from 'react-router-hash-link';

import appScreenshot from '../assets/images/payroll.png';

import { connect } from 'react-redux';
import { Actions as CREATEACCOUNTACTIONS } from 'store/actions/createAccountActions';
import { Actions as WEBINARACTIONS } from 'store/actions/webinarActions';
import Team from 'components/team/Team'
import DarkScreenshotRight from './uk/for/DarkScreenshotRight'
import LightScreenshotLeft from './uk/for/LightScreenshotLeft'
import Security from 'components/security/Security'
import RegistrationForm from 'components/common/RegistrationForm'
import RegistrationAndPayment from 'components/common/RegistrationAndPayment'
import HubSpotFormEmbed from 'components/common/HubSpotFormEmbed'
import buddySvg from 'assets/images/buddy-svg'

import 'react-add-to-calendar/dist/react-add-to-calendar.css'
import { CheckIcon, XMarkIcon, CalendarDaysIcon, GlobeEuropeAfricaIcon, CurrencyPoundIcon, UserGroupIcon, ShieldCheckIcon, ScaleIcon, ArrowsRightLeftIcon } from '@heroicons/react/24/outline'

import {
    CalculatorIcon,
    CalendarIcon,
    CloudArrowUpIcon,
    LockClosedIcon,
    ServerIcon,
    CheckCircleIcon,
    UserCircleIcon,
    MapPinIcon,
    ClipboardDocumentCheckIcon,
    DevicePhoneMobileIcon,
    ClockIcon,
    ChartBarIcon,
    CreditCardIcon,
    DocumentChartBarIcon,
    CloudIcon,
    CogIcon,
    ListBulletIcon,
    ShieldCheckIcon as ShieldCheckIconSolid, DocumentIcon, ChartPieIcon,
} from '@heroicons/react/20/solid'


import { Disclosure } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/24/outline'
import SeoHeaders from "../components/SeoHeaders";

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

function RegisterPage({
	title,
	intro,
    userInList,
    contactInList,
    saveLead,
    profile,
	isPartner,
	isUnknown,
    withPaymentInfo
}) {

    const location = useLocation()

    const countryCode = location.pathname.split('/')[1]
    const country = ['uk', 'mt', 'ie'].includes(countryCode) ? countryCode: null
    const hasPrefilledEmailParam = Boolean(new URLSearchParams(window.location.search).get('email'));
    const isUkLeadOnly = country === 'uk' && !hasPrefilledEmailParam;

    const {
        emailList,
        tags
    } = useMemo(() => {

        let emailList = 11
        let tags = {
            ukSignUp: 56
        }

        switch (country){
            case 'uk': {
                emailList = 11
                tags = {
                    ukSignUp: 56
                }
            }
        }

        return {
            emailList,
            tags
        }

    },[country]);


    useEffect(() => {
        // load initial data required for anywhere
        if (profile && profile.email && emailList) {
            contactInList({
                email: profile.email,
                list: emailList
            })
        }
    }, [profile && profile.email, emailList]);


    return (

        <React.Fragment>

            <SeoHeaders
                country={country}
                title={title}
                description={intro}
            />

            <main className="min-h-screen pb-8 sm:pb-16 md:pb-20 lg:pb-24">  {/* min-h-screen so thank-you view fills viewport */}
                <div className="mx-auto max-w-screen-xl">
                    <div className="lg:gap-8">
                        <div className="px-4 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:flex lg:items-center">
                            <div className="m-auto">
                                <h1 className="mt-4 text-4xl font-bold text-white sm:mt-5 lg:mt-6 text-center">
									{/*<span className={"logo-w inline-block"}
										  alt={"Buddy"}
										style={{
											transform: "scale(2)",
											transformOrigin: "left top",
											marginRight: "5rem"
									  	}}>
										{buddySvg}
									</span>
                                    <br />*/}
                                    <span className="text-white text-3xl font-light inline-block">
                                        {isUkLeadOnly ? "Request a Buddy demo" : "Create your Buddy trial account"}
                                    </span>
                                </h1>
                                <p className="mt-3 text-base text-gray-300 sm:mt-5 lg:text-lg mb-10">
                                    {isUkLeadOnly ? "Share a few details and a payroll specialist will be in touch." : intro}
                                </p>
                            </div>
                        </div>
                        {<div className="mt-12 sm:mt-16 lg:mt-0 lg:col-span-6" id={"leadForm"}>
                            {
                                withPaymentInfo ? (
                                    <RegistrationAndPayment  list={emailList} jurisdiction={country?.toUpperCase()} partner={isPartner} unknownPartner={isUnknown} />
                               ) : country === 'uk' && isUkLeadOnly ? (
                                    <HubSpotFormEmbed />
                               ) : (
                               <RegistrationForm
                                   list={emailList}
                                   jurisdiction={country?.toUpperCase()}
                                   partner={isPartner}
                                   unknownPartner={isUnknown}
                                   leadOnly={country === 'uk'}
                               />
                            )
                            }
                        </div>}
                    </div>
                </div>
            </main>


        </React.Fragment>

    );
}

const mapStateToProps = (state, ownProps) => {

    // const {
    //   myAgreements,
    // } = state.my

    const profile = state && state.my && state.my.profile || localStorage.getItem('userData') && JSON.parse(localStorage.getItem('userData'))

    const userInList = state.createAccount && state.createAccount.inList && state.createAccount.inList

    const countryCode = window.location.pathname.split('/')[1]
    const country = ['uk', 'mt', 'ie'].includes(countryCode) ? countryCode: null

	const countryName = country === "uk" ? "UK" : "Malta"

	const title = ownProps.for === "Bureau" ?
		"Try Buddy - Cloud Payroll Software for Payroll Bureaus, Accountants and Bookkeepers"
		: "Try Buddy - Cloud Payroll Software for Employers"
    const intro = ownProps.for === "Bureau" ?
		"Cloud payroll has never been easier. Create your trial account below to see how you can get payroll done quickly and efficiently."
		: `Cloud payroll has never been easier. Create your trial account below to see how you can get payroll done quickly and efficiently.`
    const introCta = "Discover how Buddy can transform your payroll operations today."
    const description = `${countryName} Payroll has never been easier. With Buddy's cloud ${countryName} Payroll Software, you can get payroll done quickly and efficiently.`
// intro: "Rediscover the Joy of Payroll",


    return {
		title,
		intro,
		introCta,
		description,
        userInList,
        profile,
		isPartner: ownProps.for === "Bureau",
		isUnknown: !ownProps.for,
        // showSidebar: state.sidebar.show,
        // loggedIn: state.my.profile ? true : false,
    }
}

const mapDispatchToProps = dispatch => ({
    contactInList: (data) => dispatch(CREATEACCOUNTACTIONS.contactInList(data)),
    saveLead: (data) => dispatch(CREATEACCOUNTACTIONS.saveLead(data)),
    addTag: (data) => dispatch(CREATEACCOUNTACTIONS.addTag(data)),
    setWebinar: (webinar) => dispatch(WEBINARACTIONS.setWebinar(webinar)),
    // getProfile: () => dispatch(MYACTIONS.getProfile()),
    // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
    // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RegisterPage)
